import { CheckboxGroup, Field } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';

let ResultsReportOptionsSection: React.FC<IWorksheetComponent> = () => (
  <ListFieldSection heading="Report">
    <Field
      input={<CheckboxGroup />}
      options={[
        {
          name: 'Results.ReportCoefficientOfUniformity',
        },
        {
          name: 'Results.ReportCoefficientOfCurvature',
        },
        {
          name: 'Results.ReportFinenessModulus',
        },
      ]}
    />
  </ListFieldSection>
);

ResultsReportOptionsSection = withInjectedProps(ResultsReportOptionsSection);

export { ResultsReportOptionsSection };
export default ResultsReportOptionsSection;
